<div class="hidden lg:flex">
    <div class="w-full grid gap-2 grid-cols-1 grid-rows-1">
        <div class="item-gallery w-full h-[400px] pl-2">
            <img [ngSrc]="!dataSource?.Pictures?.length || !dataSource?.Pictures?.[0]?.Webp ? cdnUrl + '/images/no-image.jpg' : dataSource?.Pictures?.[0]!.Webp"
                priority height="400" width="680"
                (error)="dataSource?.Pictures?.[0]!.Webp = cdnUrl + '/images/no-image.jpg'"
                [alt]="dataSource?.Pictures?.[0]?.Alt"
                (click)="dataSource?.Pictures?.length ? openSingleImage(0) : undefined"
                class="w-full h-full rounded-tr-xl rounded-br-xl object-cover cursor-pointer">
        </div>
    </div>
    <div class="h-[400px] w-full grid grid-cols-2 grid-rows-2 gap-2">
        <!-- *ngFor="let item of dataSource?.Pictures?.;let ?index = index;let last = last;let first = first" -->
        <div class="item-gallery relative">
            <!-- class="{{index == 1 ? 'rounded-tl-xl' : index == 3 ?  'rounded-bl-xl' : ''}}" -->
            <img [ngSrc]="!dataSource?.Pictures?.length || !dataSource?.Pictures?.[1]?.Webp ? cdnUrl + '/images/no-image.jpg' : dataSource?.Pictures?.[1]!.Webp"
                height="184" width="242" loading="lazy" class="w-full h-full object-cover cursor-pointer"
                [alt]="dataSource?.Pictures?.[1]?.Alt"
                (click)="dataSource?.Pictures?.length ? openSingleImage(1) : undefined">
        </div>
        <div class="item-gallery relative">
            <img [ngSrc]="!dataSource?.Pictures?.length || !dataSource?.Pictures?.[2]?.Webp ? cdnUrl + '/images/no-image.jpg' : dataSource?.Pictures?.[2]!.Webp"
                height="184" width="242" loading="lazy"
                (error)="dataSource?.Pictures?.[2]!.Webp = cdnUrl + '/images/no-image.jpg'"
                class="w-full h-full  rounded-tl-xl object-cover cursor-pointer" [alt]="dataSource?.Pictures?.[2]?.Alt"
                (click)="dataSource?.Pictures?.length ? openSingleImage(2) : undefined">
        </div>
        <div class="item-gallery relative ">
            <img [ngSrc]="!dataSource?.Pictures?.length || !dataSource?.Pictures?.[3]?.Webp ? cdnUrl + '/images/no-image.jpg' : dataSource?.Pictures?.[3]!.Webp"
                height="184" width="242" loading="lazy"
                (error)="dataSource?.Pictures?.[3]!.Webp = cdnUrl + '/images/no-image.jpg'"
                class="w-full h-full object-cover cursor-pointer" [alt]="dataSource?.Pictures?.[3]?.Alt"
                (click)="dataSource?.Pictures?.length ? openSingleImage(3) : undefined">
        </div>
        <div class="item-gallery relative">
            <div (click)="dataSource?.Pictures?.length ? showModalGallery() : undefined"
                class="absolute cursor-pointer text-white rounded-bl-lg bg-[rgba(0,0,0,0.3)] top-0 right-0 w-full h-full flex justify-center items-center flex-col">
                <i class="ico-Picture text-xl font-bold"></i>
                <span class="text-sm">تصاویر بیشتر</span>
            </div>

            <img [ngSrc]="!dataSource?.Pictures?.length || !dataSource?.Pictures?.[4]?.Webp ? cdnUrl + '/images/no-image.jpg' : dataSource?.Pictures?.[4]!.Webp"
                height="184" width="242" loading="lazy"
                (error)="dataSource?.Pictures?.[4]!.Webp = cdnUrl + '/images/no-image.jpg'"
                class="w-full h-full  rounded-bl-xl object-cover" [alt]="dataSource?.Pictures?.[4]?.Alt">
        </div>
    </div>
</div>


<div class="mobile-hotel-gallery-wrapper">
    <div
        class="absolute bg-slate-300/30 px-3 py-1 rounded right-[10px] bottom-[10px] text-white z-30 flex gap-1 items-center">
        <span> {{realIndexSlider}}</span>
        <span>از</span>
        <span>6</span>
    </div>
    <swiper (slideChange)="onSlideChange($event)" [config]="configSwiperGalleryWrapper" #swiperGalleryWrapper
        id="swiperGalleryWrapper">
        <ng-template swiperSlide>
            <img [ngSrc]="!dataSource?.Pictures?.length || !dataSource?.Pictures?.[0]?.Webp  ? cdnUrl + '/images/no-image.jpg' : dataSource?.Pictures?.[0]!.Webp"
                height="240" width="360" priority="high" [alt]="dataSource?.Pictures?.[0]?.Alt"
                (error)="dataSource?.Pictures?.[0]!.Webp = cdnUrl + '/images/no-image.jpg'"
                class="w-full h-full object-cover">
        </ng-template>
        <ng-template swiperSlide>
            <img [ngSrc]="!dataSource?.Pictures?.length || !dataSource?.Pictures?.[1]?.Webp ? cdnUrl + '/images/no-image.jpg' : dataSource?.Pictures?.[1]!.Webp"
                height="240" width="360" priority="low" [alt]="dataSource?.Pictures?.[1]?.Alt"
                (error)="dataSource?.Pictures?.[1]!.Webp = cdnUrl + '/images/no-image.jpg'"
                class="w-full h-full object-cover">
        </ng-template>
        <ng-template swiperSlide>
            <img [ngSrc]="!dataSource?.Pictures?.length || !dataSource?.Pictures?.[2]?.Webp ? cdnUrl + '/images/no-image.jpg' : dataSource?.Pictures?.[2]!.Webp"
                height="240" width="360" priority="low" [alt]="dataSource?.Pictures?.[2]?.Alt"
                (error)="dataSource?.Pictures?.[2]!.Webp = cdnUrl + '/images/no-image.jpg'"
                class="w-full h-full object-cover">
        </ng-template>

        <ng-template swiperSlide>
            <img [ngSrc]="!dataSource?.Pictures?.length || !dataSource?.Pictures?.[3]?.Webp ? cdnUrl + '/images/no-image.jpg' : dataSource?.Pictures?.[3]!.Webp"
                height="240" width="360" priority="low" [alt]="dataSource?.Pictures?.[3]?.Alt"
                (error)="dataSource?.Pictures?.[3]!.Webp = cdnUrl + '/images/no-image.jpg'"
                class="w-full h-full object-cover">
        </ng-template>
        <ng-template swiperSlide>
            <img [ngSrc]="!dataSource?.Pictures?.length || !dataSource?.Pictures?.[4]?.Webp ? cdnUrl + '/images/no-image.jpg' : dataSource?.Pictures?.[4]!.Webp"
                height="240" width="360" priority="low" [alt]="dataSource?.Pictures?.[4]?.Alt"
                (error)="dataSource?.Pictures?.[4]!.Webp = cdnUrl + '/images/no-image.jpg'"
                class="w-full h-full object-cover">
        </ng-template>
        <ng-template swiperSlide>
            <button (click)="showModalGallery()"
                class="flex lg:hidden flex-col items-center justify-center h-[176px] w-full mt-7">
                <i class="ico-LeftArrowCircle text-4xl text-blue"></i>
                <span class="text-sm text-black font-semibold">مشاهده بیشتر</span>
            </button>
        </ng-template>
    </swiper>
</div>